interface VehiclePriceProps {
  price: number;
  promoPrice?: number;
  variant?: 'card' | 'detail';
}

export default function VehiclePrice({ price, promoPrice, variant = 'card' }: VehiclePriceProps) {
  const promo = typeof promoPrice === 'number' && promoPrice < price ? promoPrice : undefined;

  const priceSize = variant === 'detail' ? 'text-2xl md:text-3xl' : 'text-lg';
  const oldSize = variant === 'detail' ? 'text-base md:text-lg' : 'text-sm';

  if (promo === undefined) {
    return (
      <p className={`font-bold text-primary-600 ${priceSize} mt-2`}>
        {price.toLocaleString('fr-FR')} €
      </p>
    );
  }

  return (
    <div className="mt-2 flex flex-wrap items-baseline gap-x-3 gap-y-0.5">
      <span className={`font-medium text-foreground-400 line-through ${oldSize} whitespace-nowrap`}>
        {price.toLocaleString('fr-FR')} €
      </span>
      <span className={`font-bold text-primary-600 ${priceSize} whitespace-nowrap`}>
        {promo.toLocaleString('fr-FR')} €
      </span>
    </div>
  );
}